import React, { createContext, ReactElement, ReactNode, useContext, useState } from 'react';
import { IViewProvider } from './IViewProvider';

export interface ViewProviderProps {
  value: IViewProvider;
  children?: ReactNode;
}

const ViewProviderContext = createContext({} as IViewProvider);

export function useViewProvider(): IViewProvider {
  const context = useContext(ViewProviderContext);

  if (context === undefined) {
    throw new Error('useViewProvider was used outside of its Provider');
  }

  return context;
}

export function ViewProvider({ value, children }: ViewProviderProps): ReactElement {
  const [state] = useState<IViewProvider>(value);

  return <ViewProviderContext.Provider value={state}>{children}</ViewProviderContext.Provider>;
}
